<div [ngClass]="dataConfig?.header?.icon ? 'portlet light' : ''">
  <storever-header-page *ngIf="dataConfig?.header?.icon" [icon]="dataConfig.header.icon"
                        [title]="dataConfig.header.text"
                        [isEdit]="false"
                        [isList]="dataConfig?.header.length > 0"
                        [data]="dataConfig?.header"
                        [buttonTitle]="dataConfig?.header?.rightSideButton ? dataConfig?.header?.rightSideButton.buttonTitle : null"
                        [buttonIcon]="dataConfig?.header?.rightSideButton ? dataConfig?.header?.rightSideButton.buttonIcon : null"
                        [buttonRole]="dataConfig?.header?.rightSideButton ? dataConfig?.header?.rightSideButton.role : null"
                        [buttonTitleExtra]="dataConfig?.header?.rightSideButton ? dataConfig?.header?.rightSideButton.buttonTitleExtra : null"
                        [buttonIconExtra]="dataConfig?.header?.rightSideButton ? dataConfig?.header?.rightSideButton.buttonIconExtra : null"
                        [action]="dataConfig?.header?.rightSideButton ? dataConfig?.header?.rightSideButton.action : null"
                        [href]="dataConfig?.header?.rightSideButton ? dataConfig?.header?.rightSideButton.href : null"
                        [actionType]="'openModal'"
                        [actionTypeExtra]="dataConfig?.header?.rightSideButton ? dataConfig?.header?.rightSideButton.actionTypeExtra : null"
                        (_action)="actionButton($event)">
  </storever-header-page>
  <div  [ngClass]="dataConfig?.header?.icon ? 'portlet-body' : ''">
    <div [ngClass]="{'row': dataConfig?.header?.exportExcel }" >
    <span [ngClass]="{'col-sm-11 storever-filter-with-btn-container': dataConfig?.header?.exportExcel }" >
      <storever-generic-filter
        [showSearchForm]="showFilter$ | async"
        [filter]="filter$ | async"
        [quickSearchField]="quickSearch$ | async"
        [dataConfig]="dataConfig"
        [role]="(isInRole$(dataConfig?.role) | async)"
        (toggle)="toggleFilter($event)"
        (search)="applyFilter($event)"
        (quickSearch)="applyQuickFilter($event)">
      </storever-generic-filter>
    </span>

    <span class="col-sm-1 btn-filter-container" *ngIf="dataConfig?.header?.exportExcel">
        <span   class="btn_import_excel" >
          <span>
             <span type="button" class="btn" (click)="exportAsXLSX()">
               <i class="fal fa-file-excel  fa-lg"></i> {{   'IMPORT_EXCEL_FILE' | translate:locale.language}}</span>
          </span>
        </span>
      </span>
    </div>
    <div [ngClass]="{'row': dataConfig?.header?.exportExcel }" >
    <div class="table-responsive">
      <storever-datatable #dataTableComponent
                          [striped]="true"
                          [hover]="true"
                          [data]="data$  | async"
                          [count]="count$ | async"
                          [currentPage]="page$ | async"
                          [itemsPerPage]="pageSize$ | async"
                          [orderBy]="orderBy$ | async"
                          [menuItem]="menuItem"
                          [checkBockStatus]="checkBockStatus"
                          [disablePagination]="disablePagination()"
                          (pageChange)="pageChanged($event)"
                          (pageSizeChange)="pageSizeChanged($event)"
                          (orderByChange)="orderByChanged($event)"
                          (selectedAll)="selectAll($event)"
                          (updateStore)="updateStoreContextualMenu($event)">
        <storever-datatable-column *ngFor="let item of dataConfig.content"
                                   [prop]="item['prop']"
                                   [name]="item['name'] === 'M_MENU_C_CONTEXTUEL' ?  menuTitle : (!item['hideTitle'] ? (item['name'] | translate:locale.language) : null)"
                                   [sortable]="item['sortable']">
          <ng-template let-row="row" let-value="value" storeverDatatableColumnCell >
            <div [ngSwitch]="item['type']" [ngStyle]="{'width': item['name'] === 'M_MENU_C_CONTEXTUEL' ? '55px' : null}">
<!--              <span *ngSwitchCase="'message'">{{row.displayName. ?  item['message'] : '' | translate:locale.language}}</span>-->
              <span *ngSwitchCase="'text'">
                <span *ngIf="row.calculationsCount === undefined || row.calculationsCount === null">{{value ?  value : item['emptyData'] | translate:locale.language}}</span>
                <span *ngIf="row.calculationsCount === 0 || row.calculationsCount > 0">{{value ?  value : item['emptyData'] | translate:locale.language}} <span *ngIf="row.calculationsCount === 0 && item['prop'] === 'status'">(empty)</span></span>
              </span>
              <span *ngSwitchCase="'price'">{{value ?  value + ' €': item['emptyData'] | translate:locale.language}}</span>
              <span *ngSwitchCase="((item['role'] && (isInRole$(item['role']) | async)) || !item['role']) ? 'checkBox' : ''">
                <input  *ngIf="(item['hideIfColumnEmpty'] && row[item['hideIfColumnEmpty']]) || !item['hideIfColumnEmpty']"  type="checkbox" [checked]="checkAll" (click)="toggleSelected(row)"></span>
              <span *ngSwitchCase="'routerLink'">
                <span *ngIf="(item['role'] && (isInRole$(item['role']) | async)) || !item['role'] ">
                <a [routerLink]="routerLink(item['path'], row, item['fragment'] ? item['fragment'] : null)?.path"
                   fragment="{{routerLink(item['path'], row)?.fragment ? routerLink(item['path'], row).fragment : item['fragment'] ? item['fragment'] : null}}"
                >{{value}}</a>
                </span>
              </span>
              <span *ngSwitchCase="'detailRouterLink'">
                <a [routerLink]="routerLink(item['path'], row, item['fragment'] ? item['fragment'] : null)?.path"
                   fragment="{{routerLink(item['path'], row)?.fragment ? routerLink(item['path'], row).fragment : item['fragment'] ? item['fragment'] : null}}"
                >{{value}}  &nbsp; <i class="fal fa-sm fa-edit"></i> </a>
              </span>
              <span *ngSwitchCase="'detailSubRouterLink'">
               <a *ngIf="row.uuid"  [routerLink]="['./', row.uuid]"> {{value}} <i class="fal fa-sm fa-edit"></i></a>
               <a *ngIf="!row.uuid"  [routerLink]="['./', row.subscription.uuid]"> {{value}} <i class="fal fa-sm fa-edit"></i></a>
              </span>
              <span *ngSwitchCase="'detailRouterLinkSplit'">
                <a [routerLink]="routerLink(item['path'], row, item['fragment'] ? item['fragment'] : null)?.path"
                   fragment="{{routerLink(item['path'], row)?.fragment ? routerLink(item['path'], row).fragment : item['fragment'] ? item['fragment'] : null}}"
                >{{value.split(item['splitChar'])[0]}}  &nbsp; <i class="fal fa-sm fa-edit"></i> </a>
              </span>
              <span *ngSwitchCase="'shippingEdit'" (click)="actionButton(item['path'], row)">
                 <div><a> {{value}} &nbsp; <i class="fal fa-sm fa-edit"></i></a></div>
              </span>
              <span *ngSwitchCase="'externalPortal'">
                  <a *ngIf="row.deviceID" href="https://portal.mcubedigital.com/{{getClientUUID}}/players/{{row.deviceID}}" target="_blank">{{value}}</a>
                 <a *ngIf="!row.deviceID" href="https://portal.mcubedigital.com/{{row.clientUuid}}/players/{{row.playerName}}" target="_blank">{{value}}</a>
          </span>
              <span *ngSwitchCase="'externalTracking'">
                  <a *ngIf="row[item['path']]" href="{{row[item['path']]}}" target="_blank">{{value}}</a>
                  <span *ngIf="!row[item['path']]">{{value}}</span>
          </span>
              <span *ngSwitchCase="'date'"> <span *ngIf="(item['role'] && (isInRole$(item['role']) | async)) || !item['role'] ">
                <span *ngIf="value!=='2099-12-31T00:00:00' && !item['hideData']">{{value | date: 'dd/MM/yyyy'}}</span></span>
              </span>
              <span *ngSwitchCase="'boolean'"> <span *ngIf="!item['hideTitle']">{{value ?   'Yes': 'No'}}</span></span>
              <span *ngSwitchCase="'dateTime'"> <span *ngIf="(item['role'] && (isInRole$(item['role']) | async)) || !item['role'] ">
                <span *ngIf="value!=='2099-12-31T00:00:00'">{{value | date: 'dd/MM/yyyy HH:mm:ss'}}</span></span>
              </span>
              <span *ngSwitchCase="'array'">
                <span *ngFor="let item of item['array'] " class="nav-item">
                   <span *ngIf="item.id === value ">{{item.name| translate:locale.language}}</span>
                </span>
          </span>
              <span *ngSwitchCase="'simpleArray'">
                <span *ngFor="let item of value; index as i" class="nav-item">
                   <span >{{item}}</span>
                  <span *ngIf="value[1+i]">,</span>
                </span>
          </span>
              <span *ngSwitchCase="'playerName'">
                <span *ngFor="let item of value " class="nav-item">
                   <span *ngIf="item.isDefault ">
                     <a href="https://portal.mcubedigital.com/{{getClientUUID}}/players/{{item.deviceID}}" target="_blank">{{item.name}}</a></span>
                </span>
              </span>
              <span *ngSwitchCase="'invoices-status'">
                <span *ngIf="value === 'Failed'  && row.errorMessage">
                <span  (click)="showModal($event ,'errorMessage' , row)">
<!--                  tooltip="{{row.errorMessage.replace('||', '<br />')}}"-->
                  <i class="fas fa-exclamation-triangle"></i> <span  class="failed">{{value}} ({{row.errors.length}})</span></span>
                <span *ngIf="!row.errorMessage"> {{value}}</span>
                </span>
                 <span *ngIf="value ==='Completed' && row.errorMessage">
                <span  (click)="showModal($event ,'errorMessage' , row)">
<!--                  tooltip="{{row.errorMessage.replace('||', '<br />')}}"-->
                  <i class="fas fa-exclamation-triangle" style="color: #ffc107;"></i> <span  class="warning">Partially completed ({{row.errors.length}})</span></span>
                <span *ngIf="!row.errorMessage"> {{value}}</span>
                </span>
                <span *ngIf="!row.errorMessage">{{value}}</span>
              </span>
              <span *ngSwitchCase="'LastConnectionDate'">
                <span *ngFor="let item of value " class="nav-item">
                   <span *ngIf="item.isDefault ">{{item.lastConnection}}</span>
                </span>
              </span>
              <span *ngSwitchCase="'country'">
             <div tooltip="{{row.country}}" class="famfamfam-flags {{row.countryCode?.toLowerCase()}}"
                   aria-label="Button that displays a tooltip when focused or hovered over">
             </div>
          </span>
              <span *ngSwitchCase="'iconModal'" >

                <span *ngIf="(item['role'] && (isInRole$(item['role']) | async)) || !item['role'] " >
                <span [ngStyle]="{'margin-left': item['name'] === 'M_MENU_C_CONTEXTUEL' ? '12px' : null}"
                      [tooltipPlacement]="'left'"
                      tooltip="{{item['icon'].disabled ? ('ORDER_NOT_ALLOWED_TEXT' | translate:locale.language): ((item['icon'].disabledFn && item['icon'].disabledFn(row) && item['icon'].tooltipDisabled)  ? (item['icon'].tooltipDisabled | translate:locale.language) : '' ) }}"
                      *ngIf="item['icon'].hide ? item['icon'].hide(row) : true">
                  <span (click)="showModal($event, item['icon'].modal, row)" style="cursor: pointer" [tooltipPlacement]="'left'"
                    [class.disable-icon]="item['icon'].disabled || (item['icon'].disabledFn && (item['icon'].disabled || item['icon'].disabledFn(row)))" [class.disable-icon-test]="" tooltip="{{item['icon'].tooltip | translate:locale.language}}">
                       <i id="{{'icon_' +item['name']}}" class="{{item['icon'].class}}" [ngClass]="item['icon'].classFn ? item['icon'].classFn(row) : ''"></i>
                  </span>
                </span>
                </span>
          </span>
              <span *ngSwitchCase="'iconRouter'" >
                <span  *ngFor="let item of item['data']">
                 <span (click)="showModal($event, 'Exchange', row)" > {{value}} &nbsp;
                   <i tooltip="{{item['icon'].tooltip | translate:locale.language}}" class="{{item['icon'].class}}" id="{{'icon_' +item['name']}}"></i></span>
                </span>
              </span>
              <span *ngSwitchCase="'iconModalRouter'" >

                <span  *ngFor="let item of item['data']">
                <span *ngIf="activatedRoute.snapshot.queryParams['anomalyType'] === item['name']"  tooltip="{{item['icon'].tooltip | translate:locale.language}}">
                  <span [ngStyle]="{'margin-left':  '12px' }" >
                  <span (click)="showModal($event, item['icon'].modal, row)" style="cursor: pointer">
                       <i class="{{item['icon'].class}}" id="{{'icon_' +item['name']}}"></i>
                  </span>
                  </span>
                </span>
                </span>
                <span *ngIf="!activatedRoute.snapshot.queryParams['anomalyType']">
                  <span [ngStyle]="{'margin-left':  '12px' }" tooltip="{{item['data'][2]['icon'].tooltip | translate:locale.language}}">
                        <span (click)="showModal($event, item['data'][2]['icon'].modal, row)" style="cursor: pointer">
                              <i class="{{item['data'][2]['icon'].class}}"></i>
                        </span>
                  </span>
                </span>
          </span>
          <span *ngSwitchCase="'concatenatePrice'">
                <span *ngIf="(item['role'] && (isInRole$(item['role']) | async)) || !item['role'] ">
              {{(row[item.concatenate[0]] ) ? (row[item.concatenate[0]] | currency: row[item.concatenate[1]]:'symbol') : item['emptyData'] | translate:locale.language}}
                </span>
          </span>
              <span *ngSwitchCase="'concatenate'">
              {{item.concatenate[0] }}{{row[item.concatenate[1]] }}
                {{item.concatenate[2] }}{{row[item.concatenate[3]] }}

             </span>
              <span *ngSwitchCase="'service'">
            <div [ngSwitch]="value">
              <span *ngSwitchCase="0"></span>
              <span *ngSwitchCase="1" tooltip="Audio"><i class="fa  fa-volume-up"></i></span>
              <span *ngSwitchCase="2" tooltip="Video"><i class="fa  fa-film"></i></span>
              <span *ngSwitchCase="3" tooltip="service"> <i class="far fa-cogs"></i> </span>
              <span *ngSwitchCase="4" tooltip="Maintenance"> <i class="far fa-construction"></i> </span>
              <span *ngSwitchCase="5" tooltip="Hosting"> <i class="fad fa-server"></i> </span>
            </div>

          </span>
              <span  *ngSwitchCase="'activeBillingLink'">
                  <span *ngIf="checkActiveBillingLink(row)" tooltip="This contract is active."> <i class="fa fa-flag"></i> </span>
                  <span *ngIf="!checkActiveBillingLink(row)" tooltip="This contract is off."> <i class="fa fa-fw fa-power-off"></i> </span>
              </span>
          <span *ngSwitchCase="'icon'" >
            <span>
              <span>
                  <i class="{{item['icon'].class}}"
                     [ngClass]="item['icon'].classFn ? item['icon'].classFn(row) : ''"
                     tooltip="{{item['icon'].tooltip | translate:locale.language}}"></i>
              </span>
            </span>
          </span>
              <span *ngSwitchCase="'iconList'" >
                <span  *ngFor="let item of item['data']">
                  <i class="{{item.class}}"
                     tooltip="{{item.tooltip | translate:locale.language}}{{row[item.extra]}}"></i>
                  </span>
          </span>
              <span *ngSwitchCase="'tooltipText'">
            <span>
              <span tooltip="{{item['tooltip'] +' '+ value | translate:locale.language}}">
                {{value}}
              </span>
            </span>
          </span>
          <span *ngSwitchCase="'iconListSwitch'">
               <ng-container *ngFor="let itemIcon of item['data']">
                <i  *ngIf="row[item['prop']] === itemIcon.value"
                    class="{{itemIcon.icon}}"
                    aria-hidden="true"
                    tooltip="{{itemIcon.tooltip | translate:locale.language}}"></i>
                 </ng-container>
          </span>
              <span *ngSwitchCase="'iconListSwitchService'">
               <ng-container *ngFor="let itemIcon of item['data']">
                <i  *ngIf="row[item['prop']] && row[item['prop']].length === 1 && row[item['prop']][0].id=== itemIcon.value"
                    class="{{itemIcon.icon}}"
                    aria-hidden="true"
                    tooltip="{{itemIcon.tooltip | translate:locale.language}}"></i>
                 <i  *ngIf="row[item['prop']] && row[item['prop']].length === 2 && row[item['prop']][1].id=== itemIcon.value"
                     class="{{itemIcon.icon}}"
                     aria-hidden="true"
                     tooltip="{{itemIcon.tooltip | translate:locale.language}}"></i>
                 <i  *ngIf="row[item['prop']] && row[item['prop']].length === 2 && row[item['prop']][0].id=== itemIcon.value"
                     class="{{itemIcon.icon}}"
                     aria-hidden="true"
                     tooltip="{{itemIcon.tooltip | translate:locale.language}}"></i>
                 </ng-container>
          </span>
          <span *ngSwitchCase="'select'">
            <ng-container *ngFor="let dataSelect of item['data']">
              <span [ngClass]="value === dataSelect.id ? '' : 'hide'">{{dataSelect.name}}</span>
            </ng-container>
          </span>
              <!--          <span *ngSwitchDefault>-->
              <!--            value: {{value}}-->
              <!--            item: <pre>{{item | json}}</pre>-->
              <!--          </span>-->
            </div>
          </ng-template>
        </storever-datatable-column>
      </storever-datatable>
    </div>
    </div>
  </div>
</div>

<template #genericDynamicComponent></template>

<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  <pre style="flex: 1 1 0px">data$: {{data$  | async | json}}</pre>
</div>
